import { WEEKDAYS } from '../../../utility'

export const LITERAL_TYPES = [
  'YESTERDAY',
  'TODAY',
  'TOMORROW',
  'LAST_WEEK',
  'THIS_WEEK',
  'NEXT_WEEK',
  'LAST_MONTH',
  'THIS_MONTH',
  'NEXT_MONTH',
  'LAST_90_DAYS',
  'NEXT_90_DAYS',
  'LAST_N_DAYS:',
  'NEXT_N_DAYS:',
  'NEXT_N_WEEKS:',
  'LAST_N_WEEKS:',
  'NEXT_N_MONTHS:',
  'LAST_N_MONTHS:',
  'THIS_QUARTER',
  'LAST_QUARTER',
  'NEXT_QUARTER',
  'NEXT_N_QUARTERS:',
  'LAST_N_QUARTERS:',
  'THIS_YEAR',
  'LAST_YEAR',
  'NEXT_YEAR',
  'NEXT_N_YEARS:',
  'LAST_N_YEARS:',
  'THIS_FISCAL_QUARTER',
  'LAST_FISCAL_QUARTER',
  'NEXT_FISCAL_QUARTER',
  'NEXT_N_FISCAL_​QUARTERS:',
  'LAST_N_FISCAL_​QUARTERS:',
  'THIS_FISCAL_YEAR',
  'LAST_FISCAL_YEAR',
  'NEXT_FISCAL_YEAR',
  'NEXT_N_FISCAL_​YEARS:',
  'LAST_N_FISCAL_​YEARS:'
]

export const LITERAL_TYPES_MAP = LITERAL_TYPES.reduce((res, el) => ({ ...res, [el]: el }), {})

export const NUMBER_SUFFIX_SPACER = ':'

export const isLiteral = (value) => {
  if (value && typeof value === 'string') {
    if (LITERAL_TYPES.includes(value)) return true
    for (let lt of LITERAL_TYPES) {
      if (value.indexOf(lt) === 0) return true
    }
  }
  return false
}

export const INSTANT_LITERALS = [
  {
    name: 'YESTERDAY'
  },
  {
    name: 'TODAY'
  },
  {
    name: 'TOMORROW'
  },
  {
    name: 'IN',
    type: 'INTEGER',
    afterWords: 'DAY(S)',
    defaultValue: 2
  },
  {
    name: 'NEXT',
    type: 'PICKLIST',
    picklist: WEEKDAYS,
    defaultValue: 'Monday'
  },
]
